import { render, staticRenderFns } from "./OppositionRequests.vue?vue&type=template&id=25e2c759&scoped=true&"
import script from "./OppositionRequests.vue?vue&type=script&lang=js&"
export * from "./OppositionRequests.vue?vue&type=script&lang=js&"
import style0 from "./OppositionRequests.vue?vue&type=style&index=0&id=25e2c759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e2c759",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
